import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "turboFrame"]

  connect() {}

  reloadFrame() {
    //
    // const turboFrame = document.getElementById("test")
    const fullURL = new URL("http://localhost:3000/admin/products/test")
    fullURL.searchParams.set("format", "turbo_stream")
    fullURL.searchParams.set("category_id", this.selectTarget.value)
    // console.log(fullURL.toString())
    this.turboFrameTarget.src = fullURL.toString()
    this.turboFrameTarget.reload()

    console.log(this.selectTarget.value)
  }

  disconnect() {}
}
